import { useEffect } from "react";
import { getEnv } from "@tarojs/taro";
import { supportsPassive } from "./supports-passive.js";
import { preventDefault } from "./event.js";
let totalLockCount = 0;
const BODY_LOCK_CLASS = "taroify-popup-overflow-hidden";
export const useLockScrollTaro = (shouldLock) => {
    useEffect(() => {
        if (getEnv() === "WEB" && shouldLock) {
            const touchmoveHandler = (e) => {
                preventDefault(e, true);
            };
            const lock = () => {
                document.addEventListener("touchmove", touchmoveHandler, supportsPassive ? { passive: false } : false);
                if (!totalLockCount) {
                    document.body.classList.add(BODY_LOCK_CLASS);
                }
                totalLockCount++;
            };
            const unlock = () => {
                if (totalLockCount) {
                    document.removeEventListener("touchmove", touchmoveHandler);
                    totalLockCount--;
                    if (!totalLockCount) {
                        document.body.classList.remove(BODY_LOCK_CLASS);
                    }
                }
            };
            lock();
            return () => unlock();
        }
    }, [shouldLock]);
};
